export const NAME = 'integrations';
export const CREATE_PUBLISH_TARGET_FORM_NAME = 'create-publish-target';
